import { tints } from './products';

/**
 * Optional presentation polish for families we ship copy for (title/blurb/tint).
 * The families themselves come from the API (`GET /categories`) — anything the
 * admin invents still gets a tile, styled from the fallbacks below.
 */
export const CATEGORY_PRESENTATION = [
  { family: 'Oud', title: 'Oud & Smoke', blurb: 'Resinous, deep, unmistakable.', tint: tints.smoke },
  { family: 'Floral', title: 'Florals', blurb: 'Rose, iris, orange blossom.', tint: tints.rose },
  { family: 'Amber', title: 'Amber & Spice', blurb: 'Saffron, amber, warm resins.', tint: tints.sand },
  { family: 'Woody', title: 'Woods', blurb: 'Sandalwood, cedar, vetiver.', tint: tints.sage },
  { family: 'Fresh', title: 'Fresh & Green', blurb: 'Fig, citrus, clean musk.', tint: tints.cream },
];

/** Panels cycle for families with no curated tint, so tiles never repeat back-to-back. */
export const FALLBACK_TINTS = [tints.sand, tints.smoke, tints.rose, tints.sage, tints.cream];

/**
 * Presentation for a family from the API: curated copy when we have it, else the
 * family name as the title and a generated blurb.
 */
export function presentationFor(family, index) {
  const curated = CATEGORY_PRESENTATION.find((c) => c.family === family);
  if (curated) return curated;

  return {
    family,
    title: family,
    blurb: `Every ${family.toLowerCase()} scent in the house.`,
    tint: FALLBACK_TINTS[index % FALLBACK_TINTS.length],
  };
}
